import { render, staticRenderFns } from "./DialogChurchDelete.vue?vue&type=template&id=18eb47ec&scoped=true"
import script from "./DialogChurchDelete.vue?vue&type=script&lang=js"
export * from "./DialogChurchDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb47ec",
  null
  
)

export default component.exports